export default {
  MOBILE_NUMBER: 'Please enter valid mobile number',
  PASSWORD: 'Please enter valid password',
  EMAIL_ID: 'Please enter valid email',
  REENTER_PASSWORD: 'Please re-enter password',
  FIRST_NAME: 'Please enter your first name',
  LAST_NAME: 'Please enter your last name',
};
